import React from "react";
import { useValidators } from "formvalidation/hooks";
import { InPageEditableSectionField, TwoColumnInPageEditableSectionField } from "../types";
import { InPageEditingProvider } from "../InPageEditingContext";
import ValidatorContext from "formvalidation/FormContext";
import { SidePanelSectionTemplate } from "./SidePanelSectionTemplate";

interface SidePanelDetailSectionTemplateProps {
  isInPageEditable: boolean;
  fields: Array<InPageEditableSectionField | TwoColumnInPageEditableSectionField>;
  onValueChanged: (key: string, value: any) => (Promise<void> | void);
  onSuccessfulUpdate?: (key: string, newValue: any) => Promise<void>;
  additionalContent?: JSX.Element;

  displayEmptyValues?: boolean;
}

export const SidePanelDetailSectionTemplate = (props: SidePanelDetailSectionTemplateProps) => {
  const validators = useValidators();

  return <InPageEditingProvider
    enabled={props.isInPageEditable}
    validate={validators.validateAll}
    onValueChanged={props.onValueChanged}
    onSuccessfulUpdate={props.onSuccessfulUpdate}
  >
    <ValidatorContext settings={validators.validatorSettings}>
      <div className="flex-column gap-larger">
        <SidePanelSectionTemplate
          fields={props.fields}
          isInPageEditable={props.isInPageEditable}
          displayEmptyValues={props.displayEmptyValues}
        />
        {props.additionalContent}
      </div>
    </ValidatorContext>
  </InPageEditingProvider>
}
